import { AxiosResponse } from 'axios';

import { DownloadHistory } from '@videoblocks/user-service-client';

import { downloadHistoryApi } from './userServiceConfig';

export interface DownloadHistoryParams {
    userId: number;
    search?: string;
    ownerId?: number;
    contentClasses?: Array<'video' | 'audio' | 'image'>;
    page?: number;
    resultsPerPage?: number;
    sort?: string;
    sortDir?: 'asc' | 'desc';
}

/**
 * Get the download history for a user.
 * @param params - The parameters for the download history
 * @param params.userId - The user id
 * @param params.ownerId - The owner id. For individual users, the user id should match the owner id. For org members, to get the download history for the entire org, pass in 0.
 * @param params.contentClasses - The content classes
 * @param params.page - The page number
 * @param params.resultsPerPage - The number of results per page
 * @param params.sort - The sort field
 * @param params.sortDir - The sort direction
 * @returns The download history
 */
const getDownloadHistoryByUserId = async (params: DownloadHistoryParams): Promise<DownloadHistory> => {
    // URL encode the search parameter if it exists
    const encodedParams = {
        ...params,
        ...(params.search && { search: encodeURIComponent(params.search) }),
    };
    const result = await downloadHistoryApi.getDownloadHistoryByUserId(encodedParams);
    return result.data;
};

export const DownloadHistoryApi = {
    getDownloadHistoryByUserId,
};
